import _slicedToArray from "/vercel/path0/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as $2AODx$react from "react";
import { useLayoutEffect as $2AODx$useLayoutEffect } from "@radix-ui/react-use-layout-effect";

var $1746a345f3d73bb7$var$useReactId = $2AODx$react['useId'.toString()] || function () {
  return undefined;
};

var $1746a345f3d73bb7$var$count = 0;

function $1746a345f3d73bb7$export$f680877a34711e37(deterministicId) {
  var _$2AODx$react$useStat = $2AODx$react.useState($1746a345f3d73bb7$var$useReactId()),
      _$2AODx$react$useStat2 = _slicedToArray(_$2AODx$react$useStat, 2),
      id = _$2AODx$react$useStat2[0],
      setId = _$2AODx$react$useStat2[1]; // React versions older than 18 will have client-side ids only.


  $2AODx$useLayoutEffect(function () {
    if (!deterministicId) setId(function (reactId) {
      return reactId !== null && reactId !== void 0 ? reactId : String($1746a345f3d73bb7$var$count++);
    });
  }, [deterministicId]);
  return deterministicId || (id ? "radix-".concat(id) : '');
}

export { $1746a345f3d73bb7$export$f680877a34711e37 as useId };